import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import CoreGuardian from './CoreGuardian';
import TaskGuardian from './TaskGuardian';
import ConcienciaGuardian from './ConcienciaGuardian';
import SubconcienciaGuardian from './SubconcienciaGuardian';
import InquisidorGuardian from './InquisidorGuardian';
import HiperstitionGuardian from './HiperstitionGuardian';
import GuardianWhisperBubble from './GuardianWhisperBubble';
import './GuardianOfZone.css';

export default function GuardianOfZone() {
  const { pathname } = useLocation();
  const [replayTrigger, setReplayTrigger] = useState(0);

  let match = null;
  if (pathname.startsWith('/tareas') || pathname.startsWith('/lugares')) {
    match = { Component: TaskGuardian, label: 'Guardián de Acción · Explorador' };
  } else if (pathname.startsWith('/conciencia')) {
    match = { Component: ConcienciaGuardian, label: 'Conciencia · Mentor' };
  } else if (pathname.startsWith('/subconciencia')) {
    match = { Component: SubconcienciaGuardian, label: 'Subconciencia · Fragmentos' };
  } else if (pathname.startsWith('/inquisition')) {
    match = { Component: InquisidorGuardian, label: 'Inquisidor · Centinela' };
  } else if (pathname.startsWith('/hiperstision')) {
    match = { Component: HiperstitionGuardian, label: 'Hiperstición · Polimorfo' };
  } else if (
    pathname === '/' ||
    pathname.startsWith('/profile') ||
    pathname.startsWith('/ensonacion') ||
    pathname.startsWith('/questionnaire') ||
    pathname.startsWith('/qoph') ||
    pathname.startsWith('/network')
  ) {
    match = { Component: CoreGuardian, label: 'Núcleo · Entidad Central' };
  }

  if (!match) return null;

  const { Component, label } = match;

  return (
    <div className="guardian-of-zone" title={label} aria-hidden="false" onClick={() => setReplayTrigger(prev => prev + 1)} style={{ cursor: "pointer", pointerEvents: "auto" }}>
      <GuardianWhisperBubble replayTrigger={replayTrigger} />
      <Component />
    </div>
  );
}
